import { graphql } from "api/cms-website/generated";

export const IconFragment = graphql(/* GraphQL */ `
    fragment IconFragment on ComponentElementsIcon {
        type
    }
`);
